"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import WaveDropContent from "@/components/waves/drops/WaveDropContent";
import WaveDropMetadata from "@/components/waves/drops/WaveDropMetadata";
import { useRouter } from "next/navigation";
import WaveDropReactions from "@/components/waves/drops/WaveDropReactions";
interface WaveLeaderboardDropContentProps {
  readonly drop: ExtendedDrop;
  readonly isCompetitionDrop?: boolean;
}
export const WaveLeaderboardDropContent: React.FC<WaveLeaderboardDropContentProps> = t0 => {
  const $ = _c(15);
  const {
    drop,
    isCompetitionDrop: t1
  } = t0;
  const isCompetitionDrop = t1 === undefined ? false : t1;
  const router = useRouter();
  const [activePartIndex, setActivePartIndex] = useState(0);
  let t2;
  if ($[0] !== router) {
    t2 = drop_0 => {
      router.push(`/waves?wave=${drop_0.wave.id}&serialNo=${drop_0.serial_no}/`);
    };
    $[0] = router;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const onDropContentClick = t2;
  let t3;
  if ($[2] !== activePartIndex || $[3] !== drop || $[4] !== isCompetitionDrop || $[5] !== onDropContentClick) {
    t3 = <WaveDropContent drop={drop} activePartIndex={activePartIndex} setActivePartIndex={setActivePartIndex} onDropContentClick={onDropContentClick} onLongPress={_temp} onQuoteClick={_temp2} setLongPressTriggered={_temp3} isCompetitionDrop={isCompetitionDrop} />;
    $[2] = activePartIndex;
    $[3] = drop;
    $[4] = isCompetitionDrop;
    $[5] = onDropContentClick;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== drop.metadata) {
    t4 = !!drop.metadata.length && <div className="tw-mt-2"><WaveDropMetadata metadata={drop.metadata} /></div>;
    $[7] = drop.metadata;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== drop) {
    t5 = <div className="tw-flex tw-w-full tw-items-center tw-gap-x-2 tw-gap-y-1 tw-flex-wrap"><WaveDropReactions drop={drop} /></div>;
    $[9] = drop;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = <div className="tw-flex tw-flex-col tw-gap-y-1">{t3}{t4}{t5}</div>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
function _temp() {}
function _temp2() {}
function _temp3() {}